<template>
  <v-layout
      row
      align-center
      :style="maxWidth"
  >
    <v-flex
        class="ml-3"
        :style="maxWidth"
    >
      <breadcrumbs
          :items="breadcrumbsItems"
      ></breadcrumbs>
      <v-card
          class="ma-3 col-sm-6" outlined
      >
        <v-card-title>Display Number Setting</v-card-title>
        <hr class="ma-1">
        <div class="col">
          <v-form
              ref="form"
              v-model="valid"
              lazy-validation
          >
            <div
                class="pa-3 ma-2"
                v-if="ads && ads.length > 0"
            >
              <v-row>
                <v-img
                    v-for="(ad,i) in ads"
                    :src="'/storage' + ad"
                    :key="i"
                    aspect-ratio="1"
                    class="grey lighten-2"
                    max-width="300"
                    max-height="300"
                >
                  <template v-slot:default>
                    <v-row
                        class="fill-height ma-0"
                        align="start"
                        justify="end"
                    >
                      <v-icon @click="removeAd(ad)" color="red">delete</v-icon>
                    </v-row>
                  </template>
                </v-img>
              </v-row>
            </div>

            <v-file-input
                id="ads"
                accept="image/*"
                label="Images"
                name="ads"
                show-size
                persistent-hint
                small-chips
                multiple
                hint="1440x500px"
            ></v-file-input>

            <v-row
                class="pt-3"
                align="center"
                justify="start"
                v-if="outlet.audio"
            >
              <v-col>
                <v-icon
                    @click="play()"
                >play_circle_filled
                </v-icon>
                {{ outlet.audio }}
                <v-icon
                    @click="removeAudio"
                    color="red"
                >delete
                </v-icon>
              </v-col>
            </v-row>
            <v-file-input
                id="audio"
                label="Audio"
                name="audio"
                show-size
                accept="audio/*"
                persistent-hint
                hint="sound when number is called."
            >
            </v-file-input>

            <div
                class="pa-3 ma-2">
              <v-row
                  v-if="outlet.video"
              >
                <v-col cols="4">
                  <iframe
                      :src="'/storage'+this.outlet.video"
                      frameborder="0"
                      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen
                  >
                  </iframe>
                </v-col>
                <v-col cols="1">
                  <v-icon
                      @click="removeVideo"
                      color="red"
                  >delete
                  </v-icon>
                </v-col>
              </v-row>
            </div>

            <v-file-input
                id="video"
                label="Video"
                name="video"
                show-size
                accept="video/*"
                persistent-hint
            >
            </v-file-input>

            <v-switch
                v-model="outlet.display_missed"
                label="Enable Missed Queue"
            ></v-switch>

            <v-btn
                :disabled="!valid"
                color="success"
                class="mt-4 mr-4 font-weight-bold"
                @click="submit"
            >
              Save
            </v-btn>
          </v-form>
        </div>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";

export default {
  data: () => {
    return {
      valid: true,
      previousNos: [],
      callingNo: '',
      toggleBlink: false,
      rules: [
        value => !value || !value.length || value.reduce((size, file) => size + file.size, 0) < 2500000 || 'Avatar size should be less than 2 MB!',
      ],
      breadcrumbsItems: '',
      ads: []
    };
  },
  props: ['outlet'],
  computed: {
    maxWidth() {
      return {
        maxWidth: window.outerWidth + 'px'
      }
    },
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        let ads = document.querySelector('#ads');
        let audio = document.querySelector('#audio');
        let video = document.querySelector('#video');
        let formData = new FormData();

        // image file
        for (var i = 0; i < ads.files.length; i++) {
          let file = ads.files[i];
          formData.append('ads[' + i + ']', file);
        }
        formData.append('audio', audio.files[0]);
        formData.append('video', video.files[0]);
        if (this.outlet.display_missed) formData.append('display_missed', this.outlet.display_missed);
        axios.post('/outlet/' + this.outlet.id + '/display_number_setting', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(response => {
            swal({
                title: 'Settings updated!',
                buttons: false,
                timer: 3000,
                icon: "success"
            }).then( function () {
                window.location.reload()
                window.scrollTo(0, 0)
            })
        });
      }
    },
    play() {
      let audio = new Audio('/storage' + this.outlet.audio);
      audio.play();
    },
    removeAudio() {
      axios.get('/outlet/' + this.outlet.id + '/removePath?type=audio').then(response => {
        window.location.reload();
      });
    },
    removeVideo() {
      axios.get('/outlet/' + this.outlet.id + '/removePath?type=video').then(response => {
        window.location.reload();
      });
    },
    removeAd(ad) {
      axios.get('/outlet/' + this.outlet.id + '/removePath?type=ad&ad=' + ad).then(response => {
        window.location.reload();
      });
    }
  },
  beforeMount() {
    this.ads = JSON.parse(this.outlet.ads);
    this.breadcrumbsItems = [
      {
        disabled: false,
        href: '/',
        link: true,
        text: 'Home',
      },
      {
        disabled: false,
        href: '/outlet/' + this.outlet.id + '/edit',
        link: true,
        text: this.outlet.name,
      },
      {
        disabled: true,
        href: '#',
        link: true,
        text: 'Display Setting',
      },
    ];
  }

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/DisplayNumberSettings.vue